<template>
  <nav class="navbar navbar-expand-lg navbar-default">
    <h4 class="navbar-brand">
      {{ routeName }}
    </h4>
    <button type="button" class="navbar-toggler navbar-toggle" :class="{ toggled: $sidebar.showSidebar }" @click="toggleSidebar">
      <span class="sr-only">Toggle navigation</span>
      <span class="icon-bar bar1 my-1"></span>
      <span class="icon-bar bar2 my-1"></span>
      <span class="icon-bar bar3 my-1"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="$user.loggedIn">
      <ul class="navbar-nav ml-auto">
        <li>
          <router-link :to="'/account'">
            <i class="fa fa-fw fa-user"></i> My Account
          </router-link>
        </li>
        <li>
          <span class="interactive-cursor" @click="logout()">
            <i class="fa fa-fw fa-sign-out-alt"></i> Logout
          </span>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { LOGOUT, DISPLAY_SIDEBAR } from '@/vuex/types'
  export default {
    name: 'TopNavbar',
    computed: {
      routeName () {
        return this.$route.name
      },
      ...mapGetters([
        '$sidebar'
      ])
    },
    methods: {
      toggleSidebar () {
        this.$store.commit(DISPLAY_SIDEBAR, !this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$store.commit(DISPLAY_SIDEBAR, false)
      },
      async logout () {
        this.$user.logout()
        await this.$store.dispatch(LOGOUT)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/TopNavbar.vue